document.addEventListener("turbo:load", function() {
  if (!!document.querySelector(".chat")) {
    window.scrollTo(0,document.body.scrollHeight);
  }
})

$(document).on("input", ".chat__message-body-input", function() {
  var maximum = parseInt($(".letter-counter").data("maximum"))
  $('.body-errors').addClass("d-none")
  // Normalize line endings to match Rails validation (CRLF -> LF)
  var normalizedLength = $(this).val().replace(/\r\n/g, "\n").length
  $(".letter-counter").html(maximum - normalizedLength)
})

$(document).on("click", ".chat__open, .chat__close", function(event) {
  event.preventDefault()

  $(".chat__closed").toggleClass("d-none")
  $(".chat__opened").toggleClass("d-none")
});
